import Helper from '@ember/component/helper';

import { service } from '@ember/service';

export default class CurrentRouteHelper extends Helper {
  @service router;

  compute(params, { name }) {
    const { currentRoute, currentRouteName } = this.router;
    return name ? currentRouteName : currentRoute;
  }
}
